/** @jsx h */
import { h } from "hyperapp";
import bus from "../bus";
import { playerEvents, queueEvents, mastheadPlayerEvents } from "../player/events";

export default function view(state, actions) {
  if (state.destroyed) {
    return null;
  }
  const { onDestroy, onCreate } = actions;
  const { component, isCurrentItem, items } = state;
  const Component = component;

  function play(e) {
    e.preventDefault();
    if (!isCurrentItem) {
      bus.emit(queueEvents.SET_CURRENT, {
        items,
        callback: () => {
          bus.emit(playerEvents.SET, {
            status: "playing",
            target: {
              type: "queue"
            }
          });
        }
      });
    } else {
      bus.emit(playerEvents.SET, {
        status: "playing",
        target: {
          type: "queue"
        }
      });
    }
    actions.decorateItems();
  }

  function pause(e) {
    e.preventDefault();
    bus.emit(playerEvents.SET, {
      status: "paused"
    });
  }

  function playNext(e) {
    e.preventDefault();
    bus.emit(queueEvents.PREPEND, items);
    bus.emit(mastheadPlayerEvents.WIGGLE);
    actions.decorateItems();
  }

  function addToQueue(e) {
    e.preventDefault();
    bus.emit(queueEvents.APPEND, items);
    bus.emit(mastheadPlayerEvents.WIGGLE);
    actions.decorateItems();
  }

  return (
    <div oncreate={onCreate} ondestroy={onDestroy}>
      <Component
        play={play}
        pause={pause}
        playNext={playNext}
        addToQueue={addToQueue}
        {...state}
      />
    </div>
  );
}
